
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { app } from '../main'
import { distributeWay } from '../BizTerms'

export default defineComponent({
  props: ['orderlist', 'loading'],
  setup (_, context) {
    const router = useRouter()
    const recall = (orderId: string) => {
      router.push('/map?id=' + orderId)
    }
    const del = (arg: string) => {
      app.config.globalProperties.$confirm(`見積番号${arg}を削除します。よろしいですか？`, '注意', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        fetch('ajax/delEst.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ order_id: arg })
        }).then(response => response.json())
          .then(json => {
            if (json.result === 'failure') {
              app.config.globalProperties.$message.error(`見積番号${arg}を削除できませんでした。`)
              // console.log(json)
            } else if (json.affected_rows > 0) {
              context.emit('del', arg)
              app.config.globalProperties.$message({
                type: 'success',
                message: `見積番号${arg}を削除しました。`
              })
            } else {
              app.config.globalProperties.$message('削除するものはありませんでした。')
            }
          })
      }).catch(() => {
        app.config.globalProperties.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    }
    const paneHeight = document.body.clientHeight - 280

    return {
      recall,
      del,
      paneHeight,
      distributeWay
    }
  }
})
